export const mixpanelDataMaskingFieldList = [
  'fullName',
  'firstName',
  'lastName',
  'studentFullName',
  'studentName',
  'parentName',
  'phone',
  'phone_number',
  'whatsappPhoneNumber',
  'studentPhoneNumber',
  'email',
  'personalEmail',
  'parentOrGuardianFullName',
  'parentOrGuardianPhoneNumber',
  'otherDepartment',
  'otherCollege',
  'otherParentGuardianOccupation',
  'otherPreferredLanguage',
  'otherDegree',
  'otherGraduatingYear',
  'collegeCity',
  'nativeCity',
  'pincode',
  'currentPincode',
  'nativePincode',
  'otherDegreeImCurrentlyIn',
  'selectedGender',
  'bachelorDegreeStartYear',
  'bachelorDegreeEndYear',
  'department',
  'preferredLanguage',
  'occupation',
  'intermediateOr12CompletionYear',
  'graduationYearOrExpected',
  'gender',
  'graduatingYear',
  'parentGuardianOccupation',
  'studentCurrentlyIn',
  'degree',
  'yearOfGraduation',
  'relationWithTheGuardian',
  'currentEducation',
  'singlePreferredLanguage',
  'currentState',
  'currentDistrict',
  'college',
  'nativeState',
  'nativeDistrict',
  'dateOfBirth',
  'dob',
  'selectedOccupation',
  'currentCity',
  'otherGraduationYear',
  'parentPhoneNumberCountryCode',
  'branch',
  'collegeName'
];
